const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 781 1000",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon_final"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.539,752.659c-1.927,22.914 -1.681,22.787 -12.384,202.348c-0.416,6.981 -4.989,0.478 -59.83,-63.734c-150.936,-176.727 -243.951,-356.633 -250.3,-458.349c-17.741,-284.236 198.577,-420.357 353.858,-431.7c272.298,-19.892 441.347,206.166 424.59,422.621c-2.727,35.227 -12.671,163.679 -193.697,396.91c-57.245,73.754 -114.093,136.868 -116.478,136.071c-0.584,-0.195 -3.656,-81.816 -6.159,-101.346c-0.686,-5.357 -8.647,-139.269 -9.367,-151.381c-3.325,-55.934 27.993,-38.036 79.193,-80.82c183.811,-153.596 97.177,-453.383 -124.977,-475.06c-196.46,-19.17 -352.368,240.663 -199.648,435.849c58.637,74.942 115.024,62.582 119.007,106.463c0.026,0.29 -3.5,57.158 -3.808,62.128Z",
    style: {
      fill: "#ac3f21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.48,705.203c0.94,28.845 10.371,161.689 12.957,214.652c0.976,19.989 13.194,66.646 -37.444,79.318c-14.251,3.566 -57.62,-2.863 -57.038,-49.943c0.075,-6.063 19.122,-312.56 20.275,-327.615c7.403,-96.681 -32.384,-83.051 -61.298,-131.259c-67.72,-112.91 62.619,-356.624 161.442,-199.915c29.067,46.094 59.911,158.144 4.088,216.777c-25.129,26.394 -54.906,34.05 -48.883,109.826c0.56,7.046 4.854,61.061 5.901,88.16Z",
    style: {
      fill: "#be6a15"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.e05393e29718fb5773580ec1dffdb02a.svg";
export { ForwardRef as ReactComponent };